module.exports = __webpack_public_path__ + "static/img/y9.a945883.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y9.jpg
// module id = RaJi
// module chunks = 1